import { createWebBackApi } from '../../api/webBackApi';

const API_PATH = "/api/video/editor";

const webBackApi = createWebBackApi({
  timeout: 120000,
});

export const generateEditorVideo = async (formData) => {
  try {
    const response = await webBackApi.post(API_PATH, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error generating editor video:", error);
    throw error;
  }
};

export const estimateEditorVideo = async (payload, { signal } = {}) => {
  const response = await webBackApi.post(`${API_PATH}/estimate`, payload, { signal });
  return response.data;
};

export const getMusicTracks = async () => {
  try {
    const response = await webBackApi.get('/api/video/music-tracks');
    return response.data;
  } catch (error) {
    console.error("Error fetching music tracks:", error);
    throw error;
  }
};

export const listEditorVideos = async (ftpUser) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/videos`, { params: { ftpUser } });
    return response.data;
  } catch (error) {
    console.error('Error listing editor videos:', error);
    throw error;
  }
};

export const getEditorVideoDownloadUrl = async (jobId, ftpUser) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/videos/${jobId}/download`, { params: { ftpUser } });
    const data = response.data;
    // El body llega como texto plano con la URL firmada (a veces con comillas si el
    // servidor lo tipa como JSON string), así que se normaliza a un string limpio.
    return typeof data === 'string' ? data.replace(/^"|"$/g, '') : data;
  } catch (error) {
    console.error('Error fetching editor video download url:', error);
    throw error;
  }
};

export { getVideoStatus } from '../../lisualTimelapse/api/videoService.api.js';
